import { c as _c } from "react/compiler-runtime";
import { ListItemText, ListItemIcon, MenuItem as MuiMenuItem } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
const styles = /* istanbul ignore next */({
  palette
}) => ({
  root: {
    paddingTop: 0,
    paddingBottom: 0
  },
  iconContainer: {
    color: 'inherit',
    minWidth: 'auto'
  },
  textContainer: {
    color: palette.text.onMain,
    flex: '0 1 auto',
    '& > span': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: 'block'
    }
  }
});
function MenuItem(t0) {
  const $ = _c(35);
  let label;
  let otherProps;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[0] !== t0) {
    ({
      classes: t1,
      children: t2,
      className: t3,
      Component: t4,
      icon: t5,
      isIconOnRight: t6,
      label,
      subLabel: t7,
      ariaLabel: t8,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = label;
    $[2] = otherProps;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
  } else {
    label = $[1];
    otherProps = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
    t5 = $[7];
    t6 = $[8];
    t7 = $[9];
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t1) {
    t9 = t1 === undefined ? {} : t1;
    $[11] = t1;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const classes = t9;
  const children = t2 === undefined ? null : t2;
  const className = t3 === undefined ? "" : t3;
  const Component = t4 === undefined ? "div" : t4;
  const MenuIcon = t5 === undefined ? null : t5;
  const isIconOnRight = t6 === undefined ? false : t6;
  const subLabel = t7 === undefined ? "" : t7;
  const ariaLabel = t8 === undefined ? "Show menu" : t8;
  let iconElement;
  if (MenuIcon) {
    let t10;
    if ($[13] !== MenuIcon || $[14] !== ariaLabel) {
      t10 = typeof MenuIcon === "function" ? <MenuIcon aria-label={ariaLabel} /> : MenuIcon;
      $[13] = MenuIcon;
      $[14] = ariaLabel;
      $[15] = t10;
    } else {
      t10 = $[15];
    }
    const MenuIconNode = t10;
    let t11;
    if ($[16] !== MenuIconNode || $[17] !== classes.iconContainer) {
      t11 = <ListItemIcon className={classes.iconContainer}>{MenuIconNode}</ListItemIcon>;
      $[16] = MenuIconNode;
      $[17] = classes.iconContainer;
      $[18] = t11;
    } else {
      t11 = $[18];
    }
    iconElement = t11;
  } else {
    iconElement = null;
  }
  let t10;
  if ($[19] !== classes.root) {
    t10 = {
      root: classes.root
    };
    $[19] = classes.root;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  const t11 = !isIconOnRight && iconElement;
  const t12 = !isIconOnRight && !iconElement;
  let t13;
  if ($[21] !== classes.textContainer || $[22] !== label || $[23] !== subLabel || $[24] !== t12) {
    t13 = <ListItemText className={classes.textContainer} inset={t12} primary={label} secondary={subLabel} />;
    $[21] = classes.textContainer;
    $[22] = label;
    $[23] = subLabel;
    $[24] = t12;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  const t14 = isIconOnRight && iconElement;
  let t15;
  if ($[26] !== Component || $[27] !== children || $[28] !== className || $[29] !== otherProps || $[30] !== t10 || $[31] !== t11 || $[32] !== t13 || $[33] !== t14) {
    t15 = <MuiMenuItem className={className} classes={t10} component={Component} {...otherProps}>{t11}{t13}{t14}{children}</MuiMenuItem>;
    $[26] = Component;
    $[27] = children;
    $[28] = className;
    $[29] = otherProps;
    $[30] = t10;
    $[31] = t11;
    $[32] = t13;
    $[33] = t14;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  return t15;
}
export default withStyles(styles)(MenuItem);